import React from "react"

import type { BookingSearch } from "@/lib/bookingSearch"
import { buildBookingSearchResults } from "@/lib/bookingSearch/buildResults"
import { contextPlaceholderFunction } from "@/lib/context/placeholderFunction"

export const BookingSearchContext =
  React.createContext<BookingSearch.ContextData>({
    hasAddress: false,
    perform: contextPlaceholderFunction,
    processing: `loading`,
    results: buildBookingSearchResults(),
  })
